module.exports = __webpack_public_path__ + "img/index-section7-award5.e0c8fc01.png";